import { GetServerSideProps } from 'next';
import { useRouter } from 'next/router';

import AuthoredPageRoutes from '@/components/authored-page-routes/authored-page-routes';
import { PLP_PAGE_TYPE } from '@/data/constants';
import { PreRenderProps } from '@/pages/_app';
import { getPlpViewDefinition } from '@/ssr/view-definition-plp-page-query';

import { fetchDataAndHandleErrors, withTokenRefresh } from '@/utils/ssr-utils';

export const getServerSideProps: GetServerSideProps<PreRenderProps> = withTokenRefresh(async (context: any) => {
  const data = await fetchDataAndHandleErrors(context, getPlpViewDefinition, PLP_PAGE_TYPE.COLLECTION);
  return { props: data };
});

const CollectionsPlpRoutes = (props: any) => {
  const router = useRouter();
  const slug = router.query.slug;
  const slugString = Array.isArray(slug) ? slug.join('/') : slug || '';
  return <AuthoredPageRoutes key={slugString} pageType={PLP_PAGE_TYPE.COLLECTION} {...props} />;
};

export default CollectionsPlpRoutes;
